import { reducerRegistry } from '../../../../reducerRegistry';

import listsReducersMap from './lists/reducersMap';

const combineMap = {
  lists: listsReducersMap
};

export default function combineRegistry() {
  reducerRegistry.registerByCombineMap('authUserOutputCashModule', combineMap);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/authUserOutputCash/reducers/static/combineRegistry.js